import ApiNode from "./ApiNode";

export default {
  getAllRemarkList(payload) {
    return ApiNode().get("document", { params: payload });
  },

  upsertRemark(payload) {
    return ApiNode().post("document", payload);
  },

  deleteRemark(payload) {
    return ApiNode().post("document/remove", payload);
  },

  getRemarkById(remarkId) {
    return ApiNode().get(`document/${remarkId}`);
  },

  bulkUploadRemark(payload) {
    return ApiNode().post("document/bulk", payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/RemarkService.js